import { defineComponent as _defineComponent } from 'vue'
import './styles/error-message.scss';

interface ErrorMessageProps {
  header?: string;
  content?: string;
  icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
    header: null,
    content: null,
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  header?: string;
  content?: string;
  icon?: string;
};


const header = props.header ?? '';
const content = props.content ?? '';
const icon = props.icon ?? 'mdi-alert-circle';

return { __sfc: true,props, header, content, icon }
}

})